import loadable from '@loadable/component'

export const RatingTable = loadable(() => import('./RatingTable'))
export const RatingTableAndKey = loadable(() => import('./RatingTableAndKey'))
export type { RatingTableItemProps, RatingTableProps } from './RatingTable'
export type { RatingTableAndKeyProps } from './RatingTableAndKey'
export { default as ratingTableMocks } from './__mocks__/RatingTable.mock'
